import {
  axiosDeleteRequest,
  axiosGetRequest,
  axiosPostRequest,
  axiosPutRequest,
  getHealthPictureRoute,
  getReferenceRoute,
} from '../../api';
import { CreateMedicationDto, UpdateMedicationDto } from './dtos';
import { Medication, MedicationSearchResult } from './models';

const getMedicationRoute = () => `${getHealthPictureRoute()}/medications`;
const getSearchRoute = () => `${getReferenceRoute()}/medications`;
const SEARCH_RESULTS_MAX = 50;

export const fetchMedicationsCall = (healthjourneyId: string) => {
  return axiosGetRequest<Medication[]>(
    `${getMedicationRoute()}/${healthjourneyId}`
  );
};

export const searchMedicationsCall = (searchString: string) => {
  const encodedSearchString = encodeURIComponent(searchString);
  return axiosGetRequest<MedicationSearchResult[]>(
    `${getSearchRoute()}/${encodedSearchString}/${SEARCH_RESULTS_MAX}`
  );
};

export const insertMedicationsCall = (
  newMedications: CreateMedicationDto[]
) => {
  return axiosPostRequest<CreateMedicationDto[], Medication[]>(
    `${getMedicationRoute()}`,
    newMedications
  );
};

export const updateMedicationCall = (medication: UpdateMedicationDto) => {
  return axiosPutRequest<UpdateMedicationDto, Medication>(
    `${getMedicationRoute()}`,
    medication
  );
};

export const deleteMedicationCall = (medicationId: string) =>
  axiosDeleteRequest<string, void>(`${getMedicationRoute()}/${medicationId}`);
